import React from 'react';
import ReactDOM from 'react-dom';

import Lights from 'shared/components/lights';
import { JsonApiAdapter } from 'commons/JsonApiAdapter';
import { BugsnagAdapter } from 'commons/BugsnagAdapter';
import { BottomSheet } from '../Live/BottomSheet';

export default class PopupBottomSheet {
  constructor({ element }) {
    this.element = element;
    this.rendered = false;
    this.livestreamingId = element.dataset.livestreamingId
    this.upcomingScheduleId = element.dataset.upcomingScheduleId;
  }

  init() {
    if (this.rendered || this.upcomingScheduleId == '0') {
      return;
    }

    this.rendered = true;

    this.fetchData(this.path())
      .then(this.handleResponse.bind(this))
      .catch((e) => {
        BugsnagAdapter.notify("PopupBottomSheet::init", e);
      });
  }

  handleResponse(responseData) {
    if (!responseData ||
      typeof responseData.data !== typeof {} ||
      responseData.data instanceof Array) {
      return;
    }

    Lights.offWithCloseButton.bind(this)();
    this.toggleOverflow();

    ReactDOM.render(
      <BottomSheet schedule={this.schedule(responseData)} livestreaming={this.livestreaming(responseData)} />,
      this.element
    );
  }

  livestreaming(responseData) {
    return {
      id: responseData.included[0].id,
      ...responseData.included[0].attributes
    };
  }

  schedule(responseData) {
    return {
      id: responseData.data.id,
      ...responseData.data.attributes
    };
  }

  async fetchData(path) {
    return await JsonApiAdapter.fetchApi(path);
  }

  path() {
    return `/livestreamings/${this.livestreamingId}/schedules/${this.upcomingScheduleId}`;
  }

  close() {
    this.element.remove();
    Lights.on();
    this.toggleOverflow();
  }

  toggleOverflow() {
    var bodyOverflow = document.body.style.overflow;
    if(bodyOverflow) {
      document.body.style.overflow = "";
    } else {
      document.body.style.overflow = "hidden";
    }
  }

}
